/**
 * Environment configuration
 * Reads from .env file and provides typed access to environment variables
 */

export const env = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://fesilah.ae/staging/backend/api',
  mapApiKey: process.env.REACT_APP_MAP_API_KEY || '',
  currencySymbol: process.env.REACT_APP_CURRENCY || '$',
  currencyCode: process.env.REACT_APP_CURRENCY_CODE || 'USD',
  dateLocale: process.env.REACT_APP_DATE_LOCALE || 'en-US',
  timeZone: process.env.REACT_APP_TIME_ZONE || 'Asia/Dubai',
} as const;

export default env;

